import { openInfinityWallet } from '@infinitywallet/infinity-connector';
function infinityWallet(options) {
    if (typeof window === 'undefined')
        return () => null;
    return () => {
        return {
            label: 'Infinity Wallet',
            getIcon: async () => (await import('./icon.js')).default,
            getInterface: async () => {
                const ethereumInjectionExists = window.hasOwnProperty('ethereum');
                let provider;
                // check if Infinity Wallet is injected into window.ethereum
                if (ethereumInjectionExists && window['ethereum'].isInfinityWallet) {
                    provider = window['ethereum'];
                }
                else {
                    openInfinityWallet(window.location.href, options === null || options === void 0 ? void 0 : options.chainId);
                    throw new Error('Opening Infinity Wallet! If not installed first download to use Infinity Wallet');
                }
                return {
                    provider
                };
            }
        };
    };
}
export default infinityWallet;
